export class MedicareModel {
    id?: string;
    statusId: number;
    ssn: string;
    medicareNumber: string;
    partA: any;
    partB: any;
    userId: string;
}
